<div class="row my-1 justify-content-between">
    <div class="col-12 col-lg-4 d-flex flex-column justify-content-around">
        <div class="row">
            <div class="col-auto pe-0">
                <strong class="user-select-auto">{{ strings.weekDay }} {{ strings.startDateTime }}</strong>
                @if (isMultiDayNotification) {
                    <span> -<br /></span>
                }
                <strong class="user-select-auto">{{ strings.endDateTime }}</strong>
                @if (displayDurationChange) {
                    <a class="cursor-pointer" (click)="openDurationModal()">
                        <fa-icon [icon]="faPencil" class="ms-1"></fa-icon>
                    </a>
                }
            </div>
            <div class="col d-lg-none d-block ps-0">
                <pace-notification-status-badge
                    [notification]="notification"
                    [notificationStatus]="notification.updatedStatus"
                    [showUnreadIcon]="false"
                ></pace-notification-status-badge>
            </div>
        </div>
        <div class="row">
            <div class="col mt-1 mt-lg-0">
                <span
                    ><a
                        class="cursor-pointer user-select-auto"
                        (click)="openCustomerModal()"
                        role="button"
                        [attr.aria-label]="'NOTIFICATION_DETAILS_ADDRESS_INFO_TITLE' | translate"
                        >{{ notification.address.completeName }}</a
                    ></span
                >
            </div>
        </div>
        <div class="row">
            <div class="col mt-1 mt-lg-0">
                <span class="user-select-auto">{{ notificationTypeString }}</span>
                @if (notification.isRemoteSupport) {
                    <fa-icon [icon]="faPhone" size="lg" class="ps-2"></fa-icon>
                }
            </div>
        </div>
        @if (displayClarifyText) {
            <div class="row">
                <div class="col mt-1 mt-lg-0">
                    <span class="user-select-auto" [innerHTML]="notification.clarifyText | paceUrl"></span>
                </div>
            </div>
        }
        @if (displayANALink) {
            <div class="row">
                <div class="col mt-1 mt-lg-0">
                    <span
                        ><a
                            class="cursor-pointer user-select-auto"
                            (click)="openANALink()"
                            role="button"
                            [attr.aria-label]="'NOTIFICATION_DETAILS_MARKET_MAP_LABEL' | translate"
                            >MarketMap</a
                        ></span
                    >
                </div>
            </div>
        }
    </div>
    <div class="col-12 col-lg-4 mt-3 mt-lg-0 ms-auto">
        @if (descText) {
            <div class="row mb-1 mb-lg-0">
                <strong class="col-3" translate="NOTIFICATION_DETAILS_HEADER_SYSTEM_LABEL"></strong>
                <div class="col-9">
                    <span class="notification-detail-text user-select-auto">{{ descText }}</span>
                    @if (displayInternalInfo) {
                        <span class="internal-info ms-1" (click)="openInternalInfoModal()">
                            <fa-icon [icon]="faNewspaper"></fa-icon>&nbsp;
                            <span class="badge rounded-pill bg-primary d-inline">{{
                                availableInternalInfoCounts
                            }}</span>
                        </span>
                    }
                </div>
            </div>
        }
        @if (tidorFLNumber) {
            <div class="row mb-1 mb-lg-0">
                @if (displayTechnicalIdNumber) {
                    <strong class="col-3" translate="NOTIFICATION_DETAILS_HEADER_TID_LABEL"></strong>
                }
                <div class="col-9">
                    <span class="notification-detail-text user-select-auto">{{ tidorFLNumber }}</span>
                    <span class="serial-no user-select-auto">{{ serialNo }}</span>
                    @if (notification.objectInformationLongText.length > 0) {
                        <a class="cursor-pointer" (click)="openObjectInfoModal()">
                            <fa-icon [icon]="faInfoCircle" class="ms-1"></fa-icon>
                        </a>
                    }
                </div>
            </div>
        }
        @if (displayContract) {
            <div class="row mb-1 mb-lg-0">
                <strong class="col-3" translate="NOTIFICATION_DETAILS_HEADER_CONTRACT_LABEL"></strong>
                <div class="col-9">
                    <span class="notification-detail-text user-select-auto">{{ contractType }}</span>
                    @if (!contractType) {
                        <fa-icon [icon]="faBan" class="ms-1"></fa-icon>
                    }
                    @if (notification.contract.sections.length > 0) {
                        <a class="cursor-pointer" (click)="openContractModal()">
                            <fa-icon [icon]="faInfoCircle" class="ms-1"></fa-icon>
                        </a>
                    }
                </div>
            </div>
        }
        @if (displayCustomerPONumber()) {
            <div class="row mb-1 mb-lg-0">
                <strong class="col-3" translate="NOTIFICATION_DETAILS_HEADER_AKZ_LABEL"></strong>
                <span class="col-9 notification-detail-text user-select-auto">{{ customerPurchOrder }}</span>
            </div>
        }
        @if (displayEquipment) {
            <div class="row mb-1 mb-lg-0">
                <strong class="col-3" translate="NOTIFICATION_DETAILS_HEADER_EQUIPMENT"></strong>
                <span class="col-9 notification-detail-text user-select-auto">{{ equipmentNumber }}</span>
            </div>
        }
        @if (displayModality) {
            <div class="row mb-1 mb-lg-0">
                <strong class="col-3" translate="NOTIFICATION_DETAILS_HEADER_MODALITY"></strong>
                <span class="col-9 notification-detail-text user-select-auto">{{ modality }}</span>
            </div>
        }
        @if (displayCriticality) {
            <div class="row mb-1 mb-lg-0">
                <strong class="col-3" translate="NOTIFICATION_DETAILS_HEADER_CRITICALITY"></strong>
                <div class="col-9">
                    <span class="notification-detail-text user-select-auto">{{ criticality }}</span>
                    @if (notification.updatedStatus?.canChangeCriticality()) {
                        <a class="cursor-pointer" (click)="openCriticalityModal()">
                            <fa-icon [icon]="faPencil" class="ms-1"></fa-icon>
                        </a>
                    }
                </div>
            </div>
        }
        @if (displayApprovedPCH) {
            <div class="row mb-1 mb-lg-0">
                <strong class="col-3 pe-0" translate="NOTIFICATION_DETAILS_HEADER_APPROVED_PCH"></strong>
                <div class="col-9">
                    @if (!approvedPCHDurationModel.noPCHAvailable) {
                        <span class="notification-detail-text user-select-auto mb-0">{{
                            approvedPCHDurationModel.approvedPCHDuration.start
                        }}</span>
                        <span> &nbsp;- <br /></span>
                        <span class="notification-detail-text user-select-auto mb-0">{{
                            approvedPCHDurationModel.approvedPCHDuration.end
                        }}</span>
                    } @else {
                        <span class="notification-detail-text user-select-auto mb-0 text-warning">{{
                            'NOTIFICATION_DETAILS_HEADER_NO_APPROVED_PCH' | translate
                        }}</span>
                    }
                    <a class="cursor-pointer" (click)="openPCHDurationModal()">
                        <fa-icon [icon]="faPencil" class="ms-1"></fa-icon>
                    </a>
                </div>
            </div>
        }
    </div>
    <div class="col-5 col-lg-4 d-lg-flex flex-column justify-content-around">
        <ng-content></ng-content>
    </div>

    <div class="row my-1">
        <div class="col d-flex justify-content-end d-lg-none">
            @if (notification.userStatus) {
                <fa-icon class="me-1" [icon]="faFlag"></fa-icon>
            }
            <span>{{ notification.userStatus }}</span>
        </div>
    </div>
</div>
